<template>
  <div v-if="ready" class="feature">
    <FeatureMeta :feature="featureStore.feature" />
    <FeatureInitSection :feature="featureStore.feature" />

    <div class="h-full">
      <LayoutInteractive show-cost :total-cost="totalCost">
        <template v-if="featureStore.results.length > 0 && featureStore.results[0].url" #main-top>
          <div
            :class="comparisonSlider ? 'btn--blue' : 'btn--secondary'"
            class="btn btn--sm w-full mt-0 min-w-16 opacity-80 hover:opacity-100"
            @click="comparisonSlider = !comparisonSlider"
          >
            <i class="fa-solid fa-table-columns"></i>
          </div>
        </template>

        <template #preview>
          <div v-if="featureStore.results.length > 0 && featureStore.results[0].url && featureStore.images[0]">
            <AppComparisonSlider
              v-if="comparisonSlider"
              :first="featureStore.results[0].original_url"
              :second="featureStore.results[0].url"
              :stop-at="50"
              class="min-w-full"
            />
            <img v-else :src="featureStore.results[0].url" alt="Face Swapper" class="w-full" />
          </div>
          <div v-else-if="featureStore.images.length > 0">
            <img :src="getImageURL(featureStore.images[0])" alt="Face Swapper" class="w-full" />
          </div>
          <div v-else>
            <img src="@/images/feature_icons/face-swap-intro.png" :alt="featureStore.feature.name" class="w-full" />
          </div>
        </template>

        <template #aside>
          <div class="flex flex-col gap-4">
            <label class="input-label">Face image</label>
            <AppImageUploaderInteractive v-model="featureStore.options[slug].faceImage" />
          </div>
          <hr class="my-6" />
          <div class="flex flex-col gap-4">
            <label class="input-label">Target image</label>
            <AppImageUploaderInteractive v-model="featureStore.images[0]" />
          </div>
          <hr class="my-6" />
          <div class="flex flex-col space-y-4">
            <label class="inline-flex items-center ml-2 mb-5 cursor-pointer max-w-max">
              <input v-model="featureStore.options[slug].manyFaces" type="checkbox" class="sr-only peer" />
              <div
                class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"
              ></div>
              <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Many faces</span>
            </label>
          </div>
          <div class="flex flex-col space-y-4">
            <label class="inline-flex items-center ml-2 mb-5 cursor-pointer max-w-max label-option--pro">
              <input v-model="featureStore.options[slug].nsfw" type="checkbox" class="sr-only peer" />
              <div
                class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"
              ></div>
              <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">NSFW</span>
            </label>
          </div>
        </template>
      </LayoutInteractive>
    </div>

    <PageFaceSwap />
  </div>

  <div v-else class="feature-loader">
    <img src="@/images/system/loader.gif" alt="Loader" />
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue'
  import { useFeatureSetup } from '$/composables/useFeatureSetup'
  import { useCostCalculate } from '$/composables/useCostCalculate'
  import PageFaceSwap from '&/landing_pages/PageFaceSwap.vue'
  import FeatureMeta from '&/FeatureMeta.vue'
  import AppImageUploaderInteractive from '&/AppImageUploaderInteractive.vue'
  import { getImageURL } from '$/utils'
  import AppComparisonSlider from '&/AppComparisonSlider.vue'

  const { ready, slug, featureStore, watchRestrictedOption, watchTaskOptions, LayoutInteractive, FeatureInitSection } =
    useFeatureSetup()
  const { totalCost } = useCostCalculate()

  const comparisonSlider = ref(false)

  featureStore.disableSubmit = computed(() => {
    return featureStore.images.length < 1 || !featureStore.options[slug].faceImage
  })
  watchRestrictedOption(slug, 'nsfw', true, 'nsfw')
  watchTaskOptions()
</script>
